export const BULK_INVOICE_ACTION = {
  MARK_AS_ACTIVE: "MARK_AS_ACTIVE",
  DELETE: "DELETE",
  VOID: "VOID",
  DELETE_DRAFT_VOID_OTHERS: "DELETE_DRAFT_VOID_OTHERS",
  UNLINK_TRANSACTIONS: "UNLINK_TRANSACTIONS",
  UNLINK_CREDIT_NOTES: "UNLINK_CREDIT_NOTES",
} as const;
export type BULK_INVOICE_ACTION_TYPE = keyof typeof BULK_INVOICE_ACTION;

export const BULK_INVOICE_TYPE = {
  BILL: "BILL",
  INVOICE: "INVOICE",
} as const;
export type BULK_INVOICE_TYPE_TYPE = keyof typeof BULK_INVOICE_TYPE;

export const MONTHLY_RECURRING = "MONTHLY";
export const QUARTERLY_RECURRING = "QUARTERLY";
export const YEARLY_RECURRING = "YEARLY";

export const MONTHLY_RECURRING_LABEL = "Monthly";
export const QUARTERLY_RECURRING_LABEL = "Quarterly";
export const YEARLY_RECURRING_LABEL = "Yearly";

export const INVOICE_STATUSES = {
  DRAFT: "DRAFT",
  PAID: "PAID",
  VOID: "VOID",
  PARTIALLY_PAID: "PARTIALLY_PAID",
  UNCOLLECTIBLE: "UNCOLLECTIBLE",
  DUE: "DUE",
  OVERDUE: "OVERDUE",
} as const;

export type invoiceStatusType = keyof typeof INVOICE_STATUSES;

export const INVOICE_STATUSES_OPTIONS = [
  { label: "Paid", value: INVOICE_STATUSES.PAID },
  {
    label: "Partially Paid",
    value: INVOICE_STATUSES.PARTIALLY_PAID,
  },
  {
    label: "Uncollectible",
    value: INVOICE_STATUSES.UNCOLLECTIBLE,
  },
  { label: "Due", value: INVOICE_STATUSES.DUE },
  { label: "Overdue", value: INVOICE_STATUSES.OVERDUE },
];

export const STATUS_GROUP_TYPES = {
  DRAFT: "DRAFT",
  VOID: "VOID",
  ACTIVE: "ACTIVE",
} as const;
export type STATUS_GROUP_TYPES_TYPE = keyof typeof STATUS_GROUP_TYPES;

export const ACTIVE_STATUSES = [
  INVOICE_STATUSES.PAID,
  INVOICE_STATUSES.PARTIALLY_PAID,
  INVOICE_STATUSES.UNCOLLECTIBLE,
  INVOICE_STATUSES.DUE,
  INVOICE_STATUSES.OVERDUE,
];

export const STATUS_GROUP_DATA_MAP: {
  [key in STATUS_GROUP_TYPES_TYPE]: {
    value: STATUS_GROUP_TYPES_TYPE;
    label: string;
    statuses: INVOICE_STATUSES_TYPE[];
  };
} = {
  [STATUS_GROUP_TYPES.ACTIVE]: {
    value: STATUS_GROUP_TYPES.ACTIVE,
    label: "Active",
    statuses: ACTIVE_STATUSES,
  },
  [STATUS_GROUP_TYPES.DRAFT]: {
    value: STATUS_GROUP_TYPES.DRAFT,
    label: "Draft",
    statuses: [],
  },
  [STATUS_GROUP_TYPES.VOID]: {
    value: STATUS_GROUP_TYPES.VOID,
    label: "Void",
    statuses: [],
  },
};

export type INVOICE_STATUSES_TYPE = keyof typeof INVOICE_STATUSES;

export const INVOICE_TYPE = {
  RECURRING: "RECURRING",
} as const;
export type INVOICE_TYPE_TYPE = keyof typeof INVOICE_TYPE;

export const INVOICE_TYPE_LABEL = {
  RECURRING: "Recurring",
};

export const CUSTOMER_INFO_TAB = {
  INVOICES: "INVOICES",
  DEFAULT_PRICES: "DEFAULT_PRICES",
  CREDIT_NOTES: "CREDIT_NOTES",
} as const;

export type CustomerInfoTabType =
  (typeof CUSTOMER_INFO_TAB)[keyof typeof CUSTOMER_INFO_TAB];

export const WRITTEN_OFF_UNLINK_DISABLED_TOOLTIP =
  "Once written off, Bad Debt can not be unmarked";

export const PAYMENT_INSTRUCTIONS_TEMPLATE = JSON.stringify({
  ops: [
    {
      insert:
        "Please remit payment using the details below. For bank transfers, include the invoice number as the payment reference.\n\n",
    },
    { insert: "ACH / Bank Transfer", attributes: { bold: true } },
    {
      insert:
        "\nBank: [Bank name]\nAccount Name: [Account name]\nAccount Number: [Account number]\nRouting Number: [Routing number]\n\n",
    },
    { insert: "Online Payment", attributes: { bold: true } },
    { insert: "\n[Add payment link]\n" },
  ],
});

export const INVOICE_FOOTER_TEMPLATE = JSON.stringify({
  ops: [
    {
      insert:
        "Questions about this invoice? Contact us at [email address] or [phone number].\n",
    },
  ],
});

export const TEMPLATE_HELPER_TEXT =
  "Start with the template by replacing values in the brackets, or delete it & write your own";
